module.exports = __webpack_public_path__ + "static/img/ADV-faculty-24.a4ca08b.png";


//////////////////
// WEBPACK FOOTER
// ./static/ADV-faculty-24.png
// module id = HnTt
// module chunks = 1